import React from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import PropTypes from "prop-types";
import * as ajaxActions from "../../actions/ajaxCounterActions";
import LoginForm from "./LoginForm";
import LoginPageHelper from "./LoginPageHelper";
import AutoBindComponent from "../common/AutoBindComponent";
import * as layoutActions from "../../actions/layoutActions";
import * as sessionActions from "../../actions/sessionActions";
import { throwException } from "../../actions/exceptionActions";
import redirector from "../../util/redirector";
import * as loginActions from "../../actions/loginActions";

class LoginPage extends AutoBindComponent {
    constructor(props, context) {
        super(props, context, true);

        this.state = {
            model: {},
            userLoggedIn: false,
            errors: {},
            title: "",
            voornaamHasFocus: true
        };

        this.pageHelper = new LoginPageHelper(this, redirector);
    }

    componentDidMount = () => {
        super.componentDidMount();
        this.pageHelper.init();
    };

    handleOnChange = (event) => this.pageHelper.change(event);
    handleOnRedirectToOrganisatiePage = () => this.pageHelper.redirectToOrganisatiePage();

    render() {
        const state = this.state;
        const userLoggedIn = state.userLoggedIn;
        const errors = state.errors;
        const title = state.title;
        const voornaamHasFocus = state.voornaamHasFocus;

        return (
            <LoginForm
                model={state.model}
                userLoggedIn={userLoggedIn}
                onChange={this.handleOnChange}
                onRedirectToOrganisatiePage={this.handleOnRedirectToOrganisatiePage}
                errors={errors}
                title={title}
                voornaamHasFocus={voornaamHasFocus}
            />
        );
    }
}

LoginPage.propTypes = {
    loadLayout: PropTypes.func,
    isNew: PropTypes.bool
};

function mapStateToProps(state, ownProps) {
    return {
        gebruikersnaam: state.session.gebruikersnaam,
        gebruikersEmailAdres: state.session.emailAdres,
        activeSportclubId: state.session.activeSportclubId
    };
}

function mapDispatchToProps(dispatch, ownProps) {
    return {
        ajaxActions: bindActionCreators(ajaxActions, dispatch),
        throwException: bindActionCreators(throwException, dispatch),
        loadLayout: bindActionCreators(layoutActions.loadLoginPageLayout, dispatch),
        setActiveUser: bindActionCreators(loginActions.initialiseLoginSession, dispatch),
        setActiveSportclub: bindActionCreators(sessionActions.setActiveSportclubId, dispatch),
        setUserType: bindActionCreators(sessionActions.setUserType, dispatch)
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(LoginPage);